/**
 * Brand header for the login + welcome surfaces.
 *
 * Just the Datacrate wordmark (rendered theme-adaptively by `BrandLogo`).
 * The standalone teal accent dot, the engineering tagline, and the "Private
 * beta" status pill have all been retired — the header is now a single, clean
 * wordmark so the login surface reads calm and uncluttered.
 *
 * The logo is given a generous, fixed footprint sized by HEIGHT only — its
 * native aspect is preserved (never stretched). Vertical rhythm is owned by the
 * parent layout via a single `space-y` scale.
 */
import React from 'react';
import { BrandLogo } from './BrandLogo';

interface Props {
  /** Height of the logo in CSS pixels; width auto-scales to preserve aspect. */
  logoHeight?: number;
}

export function BrandHeader({
  logoHeight = 45,
}: Props): React.JSX.Element {
  return (
    <div className="flex flex-col items-center">
      <h1 className="sr-only">Datacrate</h1>
      {/* `text-text-primary` pins the wordmark to the theme's primary text
          colour so `currentColor` resolves correctly: near-black in light mode,
          near-white in dark mode (so the logo flips to white automatically on
          the dark login background). Height reduced ~30% (64 → 45). */}
      <BrandLogo height={logoHeight} className="max-w-full text-text-primary" />
    </div>
  );
}
